module.exports = __webpack_public_path__ + "static/media/popular1.3229072c.jpg";